import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Shield, FileText, Scale } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const iconMap = {
  'privacy-policy': Shield,
  'terms': FileText,
  'nda': Scale
};

const titleMap = {
  'privacy-policy': 'Privacy Policy',
  'terms': 'Terms of Service',
  'nda': 'Universal NDA'
};

const LegalPage = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, [type]);

  const fetchContent = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/legal/${type}`);
      setContent(res.data);
    } catch (err) {
      console.error('Error fetching legal content:', err);
    } finally {
      setLoading(false);
    }
  };

  const Icon = iconMap[type] || FileText;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FAF9F7' }}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2" style={{ borderColor: '#D4AF37' }}></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FAF9F7' }} data-testid={`legal-${type}`}>
      <header className="bg-white shadow-sm" style={{ borderBottom: '1px solid #E5E1DB' }}>
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 mb-4 transition-all duration-200"
            style={{ color: '#8B7355' }}
            data-testid="legal-back-button"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Back</span>
          </button>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: '#D4AF37' }}>
              <Icon className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-light tracking-tight" style={{ color: '#2C2416' }}>
                {content?.title || titleMap[type] || 'Legal Document'}
              </h1>
              {content?.last_updated && (
                <p className="text-sm mt-1" style={{ color: '#8B7355' }}>
                  Last updated: {new Date(content.last_updated).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-10">
        <div className="bg-white border rounded-sm shadow-sm p-10" style={{ borderColor: '#E5E1DB' }}>
          <pre
            className="whitespace-pre-wrap font-sans text-sm leading-relaxed"
            style={{ color: '#2C2416' }}
            data-testid="legal-content"
          >
            {content?.content || 'Content not available.'}
          </pre>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
